import { useMutation, useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";
import type { LoginFormData } from "@/modules/LoginForm/types";

import { authRestaurantApi } from "./authRestaurantApi";
import type { AcceptInviteVariables } from "./types";

export const useLoginRestaurantMutation = () => {
  return useMutation({
    mutationFn: (data: LoginFormData) => {
      return authRestaurantApi.postLogin(data);
    },
  });
};

export const useAcceptInviteMutation = () => {
  return useMutation({
    mutationFn: ({ token, data }: AcceptInviteVariables) => {
      return authRestaurantApi.postAcceptInvite(token, data);
    },
  });
};

export const useCheckInviteTokenQuery = (token: string, options = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.checkInviteToken, token],
    queryFn: () => authRestaurantApi.checkInviteToken(token),
    retry: false,
    enabled: !!token,
    ...options,
  });

export const useLogoutRestaurantMutation = () => {
  return useMutation({
    mutationFn: ({ token }: { token: string }) => {
      return authRestaurantApi.postLogout(token);
    },
  });
};
